import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Icon from './Icon';
import { projectMedia } from '../data/site';

const ease = [0.76, 0, 0.24, 1];

/* Interactive project index: hover a name on the left, the big photo on the right changes with a wipe.
   Auto-advances every few seconds until the visitor interacts. */
export default function ProjectShowcase({ projects, onOpen }) {
  const list = projects.filter((p) => projectMedia(p));
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused || list.length < 2) return undefined;
    const t = setInterval(() => setActive((a) => (a + 1) % list.length), 4200);
    return () => clearInterval(t);
  }, [paused, list.length]);

  if (!list.length) return null;
  const p = list[Math.min(active, list.length - 1)];
  const media = projectMedia(p);

  return (
    <div className="sc" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      <ol className="sc-list">
        {list.map((item, i) => (
          <li key={item.id}>
            <button type="button" className={`sc-item${i === active ? ' on' : ''}`} onMouseEnter={() => setActive(i)} onFocus={() => setActive(i)} onClick={() => onOpen(item)}>
              <span className="sc-no">{String(i + 1).padStart(2, '0')}</span>
              <span className="sc-text"><span className="sc-name">{item.title}</span><span className="sc-cat">{item.category}</span></span>
              <Icon name="arrow" size={22} />
              <motion.span className="sc-bar" initial={false} animate={{ scaleY: i === active ? 1 : 0, opacity: i === active ? 1 : 0 }} transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }} />
            </button>
          </li>
        ))}
      </ol>

      <button type="button" className="sc-stage" onClick={() => onOpen(p)} aria-label={`Open ${p.title}`}>
        <AnimatePresence initial={false} mode="popLayout">
          <motion.img key={p.id} src={media.cover} alt={p.title} decoding="async"
            initial={{ clipPath: 'inset(0 0 0 100%)', scale: 1.15 }} animate={{ clipPath: 'inset(0 0 0 0%)', scale: 1 }} exit={{ opacity: 0.6, scale: 1.04 }}
            transition={{ duration: 1, ease }} />
        </AnimatePresence>
        <span className="sc-caption">
          <motion.span key={`t-${p.id}`} initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.3, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
            <strong>{p.title}</strong><span>{p.location} · {p.status}</span>
          </motion.span>
          <span className="sc-open">View project <Icon name="arrow" size={16} /></span>
        </span>
        {!paused && <motion.span key={`p-${active}`} className="sc-progress" initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 4.2, ease: 'linear' }} />}
      </button>
    </div>
  );
}
